import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import { useToggle } from 'usehooks-ts'

import i18n from 'modules/core/lib/i18n'

import { useGetEvaluationFormTemplates } from 'modules/ats/hooks/evaluationForms/useGetEvaluationFormTemplates'

import { CreateEvaluationFormTemplateSidepanel } from './CreateEvaluationFormTemplate/CreateEvaluationFormTemplateSidepanel'
import { EvaluationFormTemplatesList } from './EvaluationFormTemplatesList'

export const EvaluationForms = () => {
  const [newTemplateOpen, setNewTemplateOpen] = useToggle(false)
  const { loading, evaluationFormTemplates } = useGetEvaluationFormTemplates()
  const showButton = !loading && evaluationFormTemplates.length

  return (
    <Section
      illustration="single-neutral-actions-process"
      title={i18n.t('ats.evaluation_forms.settings.title')}
      description={i18n.t('ats.evaluation_forms.settings.description')}
      link={{
        href: i18n.t('ats.evaluation_forms.settings.help_center_url'),
        label: i18n.t('ats.evaluation_forms.settings.how_it_works'),
      }}
      action={
        showButton
          ? {
              label: i18n.t('ats.evaluation_forms.settings.new_template'),
              onClick: setNewTemplateOpen,
            }
          : undefined
      }
    >
      {loading ? (
        <EvaluationFormTemplatesList.Skeleton />
      ) : (
        <EvaluationFormTemplatesList
          evaluationForms={evaluationFormTemplates}
          onNewTemplateClick={setNewTemplateOpen}
        />
      )}

      {newTemplateOpen && <CreateEvaluationFormTemplateSidepanel onClose={setNewTemplateOpen} />}
    </Section>
  )
}
